<div class="checkbox_wrapper">
  <mat-checkbox [(ngModel)]="value" disabled *ngIf="readonly || view"></mat-checkbox>
  <mat-checkbox [(ngModel)]="value" #checkbox *ngIf="!readonly" (change)="change.emit($event)"></mat-checkbox>
  {{ translationCode | translate }}{{ label }}
</div>
